<template>
 <ion-page id="preferences-page" >
    <ion-content >
      <div v-if="!showBigButtons" :class="{ 'text-dark' : isDark,'text-light' : !isDark }" :style="styleOneFrame" :key="menuTrigger">

          <!-- Language -->
        <ion-item class="ion-text-wrapper">
          <ion-select
            :label="languageString"
            :value="languageInUse"
            justify="start"
            label-placement="stacked"
            @ionChange="handleChange($event,'language',null)"
            @ionCancel="handleCancel()"
            @ionDismiss="handleDismiss()"
          >
            <div v-for="item in languages">
              <ion-select-option :value="item.radio">{{ item.name }}</ion-select-option>
            </div>
          </ion-select>
        </ion-item>

        <!-- Board Coordinates -->
        <ion-item class="ion-text-wrapper">
          <ion-select
            :label="coordinateString"
            :value="coordinateSelected"
            justify="start"
            label-placement="stacked"
            @ionChange="handleChange($event,'coordinates',null)"
            @ionCancel="handleCancel()"
            @ionDismiss="handleDismiss()"
          >
            <div v-for="item in coordinates">
              <ion-select-option :value="item.radio">{{ item.name }}</ion-select-option>
            </div>
          </ion-select>
        </ion-item>

        <!-- Board Colors -->
        <ion-item>
          <ion-select
            :label="colorsString"
            :value="darkBoardColors"
            justify="start"
            label-placement="stacked"
            @ionChange="handleChange($event,'board_colors',null)"
            @ionCancel="handleCancel()"
            @ionDismiss="handleDismiss()"
          >
            <div v-for="item in colors">
              <ion-select-option :value="item.radio">{{ item.name }}</ion-select-option>
            </div>
          </ion-select>
        </ion-item>
        
        <!-- Disable Hint -->
        <ion-item>
           <ion-select
            :label="disableString"
            :value="disableHint"
            justify="start"
            label-placement="stacked"
            @ionChange="handleChange($event,'disable_hint',null)"
            @ionCancel="handleCancel()"
            @ionDismiss="handleDismiss()"
          >
          <div v-for="item in hints">
              <ion-select-option :value="item.radio">{{ item.name }}</ion-select-option>
            </div>
          </ion-select>
        </ion-item>

        <!-- Puzzle Confetti -->
        <ion-item>
          <ion-select
            :label="dailyCountString"
            :value="dailyPuzzleSelected"
            justify="start"
            label-placement="stacked"
            @ionChange="handleChange($event,'puzzle_count',null)"
            @ionCancel="handleCancel()"
            @ionDismiss="handleDismiss()"
          >
            <div v-for="item in dailyCounts">
              <ion-select-option :value="item.radio">{{ item.name }}</ion-select-option>
            </div>
          </ion-select>
        </ion-item>
      </div>
    </ion-content>
  </ion-page>
</template>

<script setup>

  import { IonCheckbox,IonLabel, IonSelect, IonSelectOption,IonRadioGroup,IonRadio, IonGrid,IonRow,IonCol,IonButton,IonItem,IonInput,IonPage, IonContent,modalController } from '@ionic/vue';


  import { getCurrentInstance, ref , watch } from 'vue';
  import ModalErrorMessage from '@/components/ModalErrorMessage.vue'
  import { t, setTranslationLanguage } from '@/composables/translateText.js'

  import { useGetData } from '@/composables/getData.js'
  import { useConnectionStore } from '@/stores/connectionStore';
  import { useWindowSizeStore } from '@/stores/windowSizeStore';
  import { forceColorsById } from '@/composables/forceColors.js'
  import { doStartupCheck } from '@/composables/startupCheck.js'
  import { availableWidthHeight }  from '@/composables/screenSize'
  import ModalActionReplacement from '@/components/ModalActionReplacement.vue';
  import ModalGenericSingleList from '@/components/ModalGenericSingleList.vue'

  const emit = defineEmits(['menu-item-click','menu-help-item-click'])

  const PREFERENCE_LANGUAGE = 0
  const PREFERENCE_COORDINATES = 1
  const PREFERENCE_COLOR = 2
  const PREFERENCE_DISABLE = 3
  const PREFERNCE_DAILY_PUZZLE_COUNT = 4

  const connectionStore = useConnectionStore()
  const isDark = ref(connectionStore.getDarkmode != "light")

  const whichMenu = localStorage.getItem("whichMenu")
  const showBigButtons = ref(whichMenu == "buttons" || connectionStore.getShowBigButtons)
  
  const languageInUse =ref(connectionStore.getLanguageIncludingSystem)

  // need some value for the button id
  if (languageInUse.value == "")
    languageInUse.value = "system"
    
  const disableString = ref("")

  const reloadTrigger = ref(0)

  // this is confusing but NOW there is no check for if the system is in dark/light mode
  // there is only light, chessvis (dark colors) and lichess (dark colors)
  const darkBoardColors = ref(connectionStore.getDarkBoardColors)
  if (darkBoardColors.value == "dark")
    darkBoardColors.value = "light"
  //console.log("DARK BOARD COLOR HERE",darkBoardColors.value)

  const disableHint = ref(connectionStore.getDisableHintButton ? "yes" : "no")

  const coordinateLocation = connectionStore.getCoordinateLocation
  const coordinateSelected = ref( (coordinateLocation != null) ? coordinateLocation : "in")
  const coordinateString = ref("")
  var coordinates = []

  const dailyPuzzleDisplayArray = ref([])
  const dailyPuzzleSelected = ref("")
  const dailyCountString = ref("")

  const colorsString = ref("")
  var colors = []
  var hints = []
  var dailyCounts = []

  const languageString = ref("")
  var languages = []

  var preferenceArray = []
  const menuTrigger = ref(0)

  const windowSizeStore = useWindowSizeStore()
  const windowSizeRef = ref({ width : windowSizeStore.getWindowSize['width'],
                        height : windowSizeStore.getWindowSize['height'] })

  const styleOneFrame = ref({
     position : "absolute",
     "overflow-y" : "scroll",
     top : "0px",
     left : "100px",
     width: "100px",
     height : "100px"
   })
  translateText()
  updateWidthHeights()
  getAccountPreferences()

  doStartupCheck(false,afterStartupCallbackRoutine)

  // do this so the page can update
  function translateText() {

    languageString.value = t("Language")
    languages = [
      { name :  t("System"), radio : "system"},
      { name :  t("English"), radio : "en"},
      { name :  t("Spanish"), radio : "es"},
      { name :  t("French"), radio : "fr"},
      { name :  t("German"), radio : "de"},
      { name :  t("Italian"), radio : "it"},
      { name :  t("Portuguese"), radio : "pt"},
      { name :  t("Swedish"), radio : "sv"},
    ]

    coordinateString.value = t("Board Coordinate Location")
    coordinates = [
      { name :  t("Inside"), radio : "in"},
      { name :  t("Outside"), radio : "out"},
      { name :  t("None"), radio : "none"},
    ]

    colorsString.value = t("Board Colors")
    colors = [
      { name :  t("Chessvis Light"), radio : "light"},
      { name :  t("Chessvis Dark"), radio : "chessvis"},
      { name :  t("Lichess Dark"), radio : "lichess"},
    ]

    disableString.value = t("Disable Hint for Puzzles")
    hints = [
      { name :  t("Yes"), radio : "yes"},
      { name :  t("No"), radio : "no"},
    ]

    dailyCountString.value= t("Daily Puzzle Count Confetti")
    dailyCounts = [
      { name :  t("None"), radio : "0"},
      { name :  ("5"), radio : "5"},
      { name :  ("10"), radio : "10"},
      { name :  ("15"), radio : "15"},
      { name :  ("20"), radio : "20"},
      { name :  ("25"), radio : "25"},
      { name :  ("30"), radio : "30"},
      { name :  ("40"), radio : "40"},
      { name :  ("50"), radio : "50"},
      { name :  ("60"), radio : "60"},
      { name :  ("70"), radio : "70"},
      { name :  ("75"), radio : "75"},
      { name :  ("80"), radio : "80"},
      { name :  ("90"), radio : "90"},
      { name :  ("100"), radio : "100"},
      { name :  ("125"), radio : "125"},
      { name :  ("150"), radio : "150"},
      { name :  ("175"), radio : "175"},
      { name :  ("200"), radio : "200"},
      { name :  ("250"), radio : "250"},

    ]
  }

  // start big button 

  const openGenericSingleListModal = async (onePreference) => {
    const modal = await modalController.create({
      component: ModalGenericSingleList,
      componentProps: {
        displayArray : onePreference.array,
        initialValue : onePreference.value,
        title : onePreference.text      }
    });

    modal.present();

    const { data, role } = await modal.onWillDismiss();

    //console.log("Back from modal",data,role)

    if (role === 'confirm') {
      // did user leave the select the same?
      if (data.selected == onePreference.value) {
        delayBeforeShowingPreferences()
        return
      }

      //console.log("CONFIRM in static",data)
      handleChange(null,onePreference.code,data.selected)

      //setOptions(data.selected)
   }
    delayBeforeShowingPreferences()

  };

  function preferenceClick(index) {
    const onePreference = preferenceArray[index]
    openGenericSingleListModal(onePreference)
    
  }

  // delay lets windows close so we can then open the actual value selection

  function delayBeforeShowingPreferences() {

    let timerSleepAmount = 250

    function oneInterval() {
      clearInterval(id)
      openPreferenceModal()
    }
    var id = setInterval(oneInterval, timerSleepAmount)
  }

  function delayBeforeShowingOption(optionId) {

    let timerSleepAmount = 250

    function oneInterval() {
      clearInterval(id)
      preferenceClick(optionId)
    }
    var id = setInterval(oneInterval, timerSleepAmount)
  }

  function currentDisplayName(array,current) {
    for (var i=0; i < array.length; i++)
      if (array[i].radio == current)
        return (array[i].name)
    return ("")
  }

  const openPreferenceModal = async () => {

    preferenceArray = []

    preferenceArray.push({text : languageString.value, code : "language",
                value: languageInUse.value, array: languages,
                current : currentDisplayName(languages,languageInUse.value),
                data : { index : PREFERENCE_LANGUAGE}})
    preferenceArray.push({text : coordinateString.value, code : "coordinates" ,
                value: coordinateSelected.value, array: coordinates,
                current : currentDisplayName(coordinates,coordinateSelected.value),
                data : { index : PREFERENCE_COORDINATES}})   
    preferenceArray.push({text : colorsString.value, code : "board_colors",
                value: darkBoardColors.value, array:colors,
                current : currentDisplayName(colors,darkBoardColors.value),
                data : { index : PREFERENCE_COLOR}})   
    preferenceArray.push({text : disableString.value,  code : "disable_hint" ,
                value: disableHint.value, array:hints,
                current : currentDisplayName(hints,disableHint.value),
                data : { index : PREFERENCE_DISABLE}})   
    preferenceArray.push({text : dailyCountString.value, code : "puzzle_count",
                value: dailyPuzzleSelected.value, array: dailyCounts,
                current : currentDisplayName(dailyCounts,dailyPuzzleSelected.value),
                data : { index : PREFERNCE_DAILY_PUZZLE_COUNT}})   
    
    const modal = await modalController.create({
      component: ModalActionReplacement,
      componentProps: {
        displayArray : preferenceArray,
        title : t("Preferences")
       }
    });

    modal.present();

    const { data, role } = await modal.onWillDismiss();

    //console.log("ROLE ",role,data)
    if (role === 'selected') {
      //console.log("CONFIRM in static",data)
      delayBeforeShowingOption(data)
   }
   else {
      //console.log("emit to big_button_menu")
      emit("menu-item-click","big_button_menu",t("Big Button Menu"),"buttons")
   }
  };

  // end big buttion approach


  const openErrorModal = async (programName,errorMessage) => {
    const modal = await modalController.create({
      component: ModalErrorMessage,
      componentProps: {
        type : "commError",
        program : programName ,
        errorMessage : errorMessage
      }
    });

    modal.present();

    const { data, role } = await modal.onWillDismiss();
  };

  function afterStartupCallbackRoutine(stuffChanged,errorProgram,errorEntry) {
    if (errorProgram != null)
      openErrorModal(errorProgram,errorEntry)
    updateWidthHeights()
    menuTrigger.value++
  }

watch(() => windowSizeStore.getWindowSize, () => {
    //console.log('*********** window size changes detected')
    windowSizeRef.value = { width : windowSizeStore.getWindowSize['width'],
                      height : windowSizeStore.getWindowSize['height'] }
    //console.log("*** logoff new window size",windowSizeRef.value)
    updateWidthHeights()
    menuTrigger.value++
  })

 function updateWidthHeights() {
  
    const availableSpace = availableWidthHeight()
    const oneframePositionTop = availableSpace.topIndent
    const oneframePositionLeft = availableSpace.leftRightIndent + availableSpace.leftIndent
    const oneframeHeight = availableSpace.height - oneframePositionTop + availableSpace.topIndent
    const oneframeWidth = availableSpace.width - availableSpace.leftRightIndent * 2

    styleOneFrame.value.height = oneframeHeight + "px"
    styleOneFrame.value.width = oneframeWidth + "px"
    styleOneFrame.value.top = oneframePositionTop + "px"
    styleOneFrame.value.left = oneframePositionLeft + "px"
  }

  function updateValue(name,value) {
     // update the server
     var formData = {
      name : name,
      value : value
    }
    //console.log(formData)
    useGetData("chessvis_preference_set_option.php", formData, processUpdateJsonResponse)
    
  }

  function handleChange(ev,which,bigButtonValue) {

    const valueSelected = (ev == null) ? bigButtonValue : ev.detail.value
    //console.log('ionChange fired with value: ' + valueSelected,which);

    switch (which) {
      case "language" :
        // if language changed, reload page
        if (languageInUse.value ==valueSelected)
          break
        connectionStore.setLanguageIncludingSystem((valueSelected == "system") ? "" : valueSelected)
        languageInUse.value = valueSelected
        setTranslationLanguage()
        translateText()
        //window.location.reload(); // Or simply location.reload();
        break
      case "disable_hint" :
        connectionStore.setDisableHintButton( (valueSelected == "yes"))
        break
      case "board_colors" :
        connectionStore.setDarkBoardColors(valueSelected)
        darkBoardColors.value =valueSelected
        break
      case "coordinates" :
        coordinateSelected.value =valueSelected
        connectionStore.setCoordinateLocation(coordinateSelected.value)
        updateValue("coordinate",coordinateSelected.value)
        break
      case "puzzle_count" :
        dailyPuzzleSelected.value =valueSelected
        updateValue("puzzle_count",dailyPuzzleSelected.value)
         break
    }
   
  }

  function handleCancel() {
    //console.log('ionCancel fired');
  }
  function handleDismiss() {
    //console.log('ionDismiss fired');
  }

  function processUpdateJsonResponse (json) {
    //console.log("update single value return ",json)
    if (json.hasOwnProperty('error')) {
      openErrorModal(json['programRun'],json['error'])
      return;
    }
  }

  function processJsonResponse (json) {
    //console.log(" in account preferences callback",json)
    if (json.hasOwnProperty('error')) {
      openErrorModal(json['programRun'],json['error'])
      return;
    }
    coordinateSelected.value = json['coordinate_initial']
    dailyPuzzleSelected.value = "" + json['puzzle_initial']
 
    if (showBigButtons.value)
      openPreferenceModal()
  }

  function getAccountPreferences() {
    var formData = { }
    useGetData("chessvis_preference_get_options.php", formData, processJsonResponse)
  }

</script>

 ion-select {
        width: 100%; /* or a specific pixel value like 200px */
        max-width: 100%; /* or a specific pixel value */
    }


     ion-select::part(container) {
        width: 100%;
    }

ion-select label-text-wrapper {
  max-width: none; /* Remove default max-width */
  width: 400px; /* Or your desired width */
}

ion-select label-text-wrapper label-text {
  text-overflow: unset; /* Prevent text truncation */
  overflow: visible; /* Allow text to overflow if needed */
}

ion-select::part(text) {
  width: 100%;
}
<style scoped>

</style>
